// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: rgba(0, 0, 0, 0) ;
}

.active {
  font-family: var(--font);
  font-weight: 700;
  color: black !important;
}

.not-active {
  font-family: var(--font);
  font-weight: 400;
  color: black !important;
}

ion-label {
  font-size: 16px;
  color: black !important;
}

.container-mode-mobile {
  background: white;
  border-radius: 42px 42px 0 0;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 9px 16px;
}

.content-desktop {
  width: 25%;
  height: 335px;
  right: 0.5%;
  position: fixed;
}
.content-desktop .container-mode-desktop {
  width: 80%;
  height: 200px;
  border-radius: 0 0 27px 27px;
  box-shadow: 0px 20px 94px rgba(32, 17, 87, 0.34);
  margin: 0 auto;
  background: #ffffff;
}
.content-desktop .container-mode-desktop ion-item {
  --background: transparent;
}

.btn-filter {
  width: 100%;
  height: 30px;
  border-radius: 20px;
  font-family: var(--font);
  font-weight: 700;
  font-size: 1rem;
}

.btn-bloc {
  position: fixed;
  height: 35px;
  background-color: #fff;
  bottom: 0;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/app/components/filter-by/filter-by.component.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;AACJ;;AACA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,uBAAA;AAGJ;;AADA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,uBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,uBAAA;AAMJ;;AAHA;EACI,iBAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAMJ;;AAHA;EACI,UAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAMJ;AALI;EACI,UAAA;EACA,aAAA;EACA,4BAAA;EACA,gDAAA;EACA,cAAA;EACA,mBAAA;AAOR;AANQ;EACI,yBAAA;AAQZ;;AAJA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EAAyB,gBAAA;EACzB,eAAA;AAQJ;;AANA;EACI,eAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AASJ","sourcesContent":["ion-content{\n    --background: rgba(0, 0, 0, 0) ;\n}\n.active{\n    font-family: var(--font); font-weight: 700;;\n    color: black !important;\n}\n.not-active{\n    font-family: var(--font); font-weight: 400;;\n    color: black !important;\n}\nion-label{\n    font-size: 16px;\n    color: black !important;\n    // --color: black !important;\n}\n.container-mode-mobile{\n    background: white;\n    border-radius: 42px 42px 0 0;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    padding: 9px 16px;\n    \n}\n.content-desktop{\n    width: 25%;\n    height: 335px;\n    right: 0.5%;\n    position: fixed;\n    .container-mode-desktop{\n        width: 80%;\n        height: 200px;\n        border-radius: 0 0 27px 27px;\n        box-shadow: 0px 20px 94px rgba(32, 17, 87, 0.34);\n        margin: 0 auto;\n        background: #ffffff;\n        ion-item{\n            --background: transparent;\n        }\n    }\n}\n.btn-filter{\n    width: 100%;\n    height: 30px;\n    border-radius: 20px;\n    font-family: var(--font);font-weight: 700;\n    font-size: 1rem;\n}\n.btn-bloc{\n    position: fixed;\n    height: 35px;\n    background-color: #fff;\n    bottom: 0;\n    width: 90%;\n    left: 50%;\n    transform: translateX(-50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
